<template>
  <div
    v-if="visible"
    class="sm:hidden bg-yellow-50 border-b border-yellow-200"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <Icon
            icon="heroicons:exclamation-triangle-solid"
            class="w-5 h-5 text-yellow-600 mr-2"
          />
          <span class="text-sm text-yellow-800">为了您良好的体验，请尽量在桌面端或者大屏上观看。</span>
        </div>
        <button
          class="text-yellow-600 hover:text-yellow-800 transition-colors"
          @click="dismiss"
        >
          <Icon
            icon="heroicons:x-mark"
            class="w-4 h-4"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Icon } from '@iconify/vue'
import { loadFromStorage, saveToStorage } from '@/utils/storage'
import { STORAGE_KEYS } from '@/constants/keys'

const visible = ref(true)

function dismiss() {
  visible.value = false
  saveToStorage(STORAGE_KEYS.HIDE_MOBILE_WARNING, true)
}

onMounted(() => {
  visible.value = !loadFromStorage<boolean>(STORAGE_KEYS.HIDE_MOBILE_WARNING, false)
})
</script>
